"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#ffe100";
const headerTextColor = "#000000";
const headerBackgroundColor = "#ffe100";
const mainInfoPortrait = headerTextColor;
const mainInfoLandscape = headerTextColor;
const fontFamily = `
@font-face {
  font-family: 'TUIType';
  src: url('/fonts/tuitype/TUIType-LATN-W/TUIType.eot');
  src: url('/fonts/tuitype/TUIType-LATN-W/TUIType.eot?#iefix') format('embedded-opentype'),
       url('/fonts/tuitype/TUIType-LATN-W/TUIType.woff') format('woff'),
       url('/fonts/tuitype/TUIType-LATN-W/TUIType.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'TUIType';
  src: url('/fonts/tuitype/TUIType-Bold-LATN-W/TUIType.eot');
  src: url('/fonts/tuitype/TUIType-Bold-LATN-W/TUIType.eot?#iefix') format('embedded-opentype'),
       url('/fonts/tuitype/TUIType-Bold-LATN-W/TUIType.woff') format('woff'),
       url('/fonts/tuitype/TUIType-Bold-LATN-W/TUIType.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'TUIType';
  src: url('/fonts/tuitype/TUIType-Light-LATN-W/TUIType.eot');
  src: url('/fonts/tuitype/TUIType-Light-LATN-W/TUIType.eot?#iefix') format('embedded-opentype'),
       url('/fonts/tuitype/TUIType-Light-LATN-W/TUIType.woff') format('woff'),
       url('/fonts/tuitype/TUIType-Light-LATN-W/TUIType.ttf') format('truetype');
  font-weight: 200;
  font-style: normal;
}
html {
    font-family: "TUIType", sans-serif ;
}

`;
exports.default = {
    fontFamily,
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerTextColor,
    headerBackgroundColor,
    style,
};
